import { render, staticRenderFns } from "./assignExpense.vue?vue&type=template&id=bde4779c&scoped=true"
import script from "./assignExpense.vue?vue&type=script&lang=js"
export * from "./assignExpense.vue?vue&type=script&lang=js"
import style0 from "./assignExpense.vue?vue&type=style&index=0&id=bde4779c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde4779c",
  null
  
)

export default component.exports